import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../baseClasses/BaseComponent';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';
import moment from 'moment';
import trashIcon from '../../assets/images/trash-icon.svg';
import trashFilledIcon from '../../assets/images/trash-icon-filled.svg';
import arrowIcon from '../../assets/images/forward-arrow-icon.svg';
import dataModel from '../../models/DataModel';
import PageStateDAO from '../../dao/PageStateDAO';
import { PageNames } from '../../constants/ReduxConstants';
import { task_flat } from '../../dao/TasksDAO';
import Animate from '../../components/Animate';
import { project_root } from '../../dao/ProjectsDAO';
import './NotificationCard.scss';
import ReduxConstants from '../../constants/ReduxConstants';

export class NotificationCard extends BaseComponent {
  constructor(props) {

    NotificationCard.propTypes = {
      notification: PropTypes.object.isRequired,
    };
    super(props);

    this.state = { 
      isSelected: false,
      deleteCard: false,
      deleting: false,
    };

    const currentRole = dataModel.usersDAO.currentUser ? dataModel.usersDAO.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }
  componentDidMount() {
    const { notification, isMobile } = this.props;
    const { notifiable_type } = notification;
    if (isMobile && (notifiable_type == 'Closeout' || notifiable_type == 'Location' || notifiable_type == 'Build' || notifiable_type == 'UserBuildAssignment')) {
      this.navigateEnabled = false;
    }
    else this.navigateEnabled = true;
  }

  shouldComponentUpdate(nextProps, nextState){
    if(nextState.isSelected && !nextProps.selected){
      // close animation
      this.closeAction = true;
    }
    return true;
  }

  handleDelete(e){
    e.stopPropagation();
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: 'Are you sure you want to delete this Notification? This action cannot be undone.',
      cancelButtonText: 'CANCEL',
      okButtonText: 'DELETE',
      width: 320,
      height: 182,
      handleOwnerOk: () =>  {
        this.handleAnimateTrashClick();
      },
    });
  }

  handleAnimateTrashClick() {
    setTimeout(() => {
      const section = this.props.section;
      if (
        this.dateCategories &&
        this.dateCategories[section] &&
        this.dateCategories[section].length == 1 &&
        this.props.prepareDelete
      ) {
        self.props.prepareDelete(section);
      }
      this.setState({ deleteCard: true });
    }, 500);
    this.setState({ deleting: true });
  }

  handleArrowClick(e) {
    e.stopPropagation();
    this.handleCardClick(this.props.notification.id);
  }

  async handleCardClick() {
    // if mobile, flag is passed down from <NotificationsWrapper>
    const { isMobile, notification } = this.props;

    // TODO: this function needs some TLC
    if (isMobile) {
      if (
        notification.notifiable_type == 'Project' ||
        notification.notifiable_type == 'ProjectUser'
      ) {
        //set the Details tab as selected tab on PageStateDAO
        PageStateDAO.setPageStateEntry(PageNames.MOBILE_PROJECT_DETAIL, 'tabSelected', 'Details');
        this.navigateToMobileProject(notification.project_id);
      } else if (
        notification.notifiable_type == 'UserTaskAssignment' ||
        notification.notifiable_type == 'CompletionCriterion'
      ) {
        let taskId = null;
        if (
          notification.task_id &&
          typeof notification.task_id == 'number' &&
          Number.isInteger(notification.task_id)
        ) {
          taskId = notification.task_id;
        }
        if (taskId) {
          const task = await dataModel.tasksDAO.getTask(taskId, { recordDescriptor: task_flat });
          if (task) {
            this.navigateToMobileTask(task);
          }
        }
      }
      else if (
        notification.notifiable_type == 'Location'
      ) {
        this.navigateToLocation(
            notification.notifiable_id
        );
      }
      else {
        let task = await dataModel.tasksDAO.getTask(notification.notifiable_id, { recordDescriptor: task_flat });
        if (task) {
          this.navigateToMobileTask(task);
        }
      }
    } else {
      this.props.notificationsDataModel.currentNotification = notification;
      if (
        notification.notifiable_type == 'Project' ||
        notification.notifiable_type == 'ProjectUser'
      ) {
        this.navigateToProject(
          notification.project_id
            ? notification.project_id
            : notification.notifiable_id
        );
        // must be a project
      } else if (notification.notifiable_type == 'UserTaskAssignment') {
        let taskId = null;
        if (
          notification.task_id &&
          typeof notification.task_id == 'number' &&
          Number.isInteger(notification.task_id)
        ) {
          taskId = notification.task_id;
        }
        if (taskId) {
          const task = await dataModel.tasksDAO.getTask(taskId, { recordDescriptor: task_flat });
          if (task) {
            this.navigateToTask(task);
          }
        }
      } else if (notification.notifiable_type == 'Task') {
        const task = await dataModel.tasksDAO.getTask(notification.notifiable_id, { recordDescriptor: task_flat });
        if (task) {
          this.navigateToTask(task);
        }
      } else if (notification.notifiable_type == 'CompletionCriterion') {
        if (notification.task_id) {
          const task = await dataModel.tasksDAO.getTask(notification.task_id, { recordDescriptor: task_flat });
          if (task) {
            this.navigateToTask(task);
          }
        }
      } else if (notification.notifiable_type == 'Closeout') {
        this.analyticsLogger.logCloseoutNotification('CloseoutDocumentInApp');
        // for now we have two possible destinations when a closeout
        // notification is clicked...
        let path = (notification.client_data && notification.client_data.destination && notification.client_data.destination == ReduxConstants.CLOSEOUT_SUMMARY) ? '/projects/closeouts' : ('/por/project/' + notification.project_id + '/location/all?tab=closeouts&navigation=notification');
        // TODO: does not redirect correctly to POR Location Documents
        // let path = (notification.client_data && notification.client_data.destination && notification.client_data.destination == ReduxConstants.CLOSEOUT_SUMMARY) ? '/projects/closeouts' : ('/por/location/' + notification.location_id + '/project/' + notification.project_id + '/closeout/' + notification.notifiable_id + '?navigation=notification')
        this.props.history.push(path);
      } else if (notification.notifiable_type == 'ProgressReport') {
        this.analyticsLogger.logCloseoutNotification('ProgressReportDocumentInApp');
        // for now we have two possible destinations when a closeout
        // notification is clicked...
        let path = (notification.client_data && notification.client_data.destination && notification.client_data.destination == ReduxConstants.CLOSEOUT_SUMMARY) ? '/projects/closeouts' : ('/por/project/' + notification.project_id + '/location/all?tab=progress_reports&navigation=notification');
        // TODO: does not redirect correctly to POR Location Documents
        // let path = (notification.client_data && notification.client_data.destination && notification.client_data.destination == ReduxConstants.CLOSEOUT_SUMMARY) ? '/projects/closeouts' : ('/por/location/' + notification.location_id + '/project/' + notification.project_id + '/closeout/' + notification.notifiable_id + '?navigation=notification')
        this.props.history.push(path);
      }
      else if (
        notification.notifiable_type == 'Location'
      ) {
        this.navigateToLocation(
            notification.notifiable_id
        );
      }
    }

    if (this.props.handleUpdateNotification) {
      this.props.handleUpdateNotification(notification);
    }
  }

  handleCloseAction(){
    this.setState({ 
      isSelected: false,
    });
    this.closeAction = false;
  }

  handleNotificationDelete() {
    this.props.notificationsDataModel.markActedOn(this.props.notification);
  }

  handleNotificationSelection(e){
    if(this.state.isSelected){
      this.closeAction = true;
      this.setState({ closeAction: true });
    }
    else{
      this.setState({ isSelected: true });
    }
    this.props.handleSelectNotification(this.props.notification);
  }

  handleTrashClick(){    
    this.handleNotificationDelete();
    this.setState({ deleteCard: false, deleting: false });
  }

  navigateToTask(task) {
    this.analyticsLogger.logNotifications('NotificationTaskNavigation');
    if (task.project_id) {
      dataModel.projectsDAO.getProject(task.project_id, { recordDescriptor: project_root }).then(project => {
        if (project) {
          if (project.company.id != this.props.currentCompany.id) {
            dataModel.companiesDAO.getCurrentCompany(project.company.id).then(company => {
              if (company) {
                this.props.history.push(
                  '/tasks/project/' + project.id + '/task/' + task.id
                );
              }
            });
          } else {
            this.props.history.push('/tasks/project/' + project.id + '/task/' + task.id);
          }
        }
      });
    }
  }

  navigateToLocation(location_id) {
    this.analyticsLogger.logNotifications('NotificationLocationNavigation');
    if (location_id) {
      dataModel.locationsDAO.getLocation(location_id, { recordDescriptor: { location: {} } }).then(location => {
        if (location) {
          this.props.history.push(
            '/por/location/' + location_id + '/edit/'
          );
        }
      });
    }
  }

  navigateToMobileTask(task) {
    this.analyticsLogger.logNotifications('NotificationTaskNavigation');
    if (task.project) {
      let project = task.project;
      if (project.company.id != this.props.currentCompany.id) {
        dataModel.companiesDAO.getCurrentCompany(project.company.id).then(company => {
          if (company) {
            this.props.history.push('/mobile/projects-tasks/task/' + task.id);
          }
        });
      } else {
        this.props.history.push('/mobile/projects-tasks/task/' + task.id);
      }
    }
    else {
      this.getProjectFromTask(task, project => {
        if (project) {
          if (project.company.id != this.props.currentCompany.id) {
            dataModel.companiesDAO.getCurrentCompany(project.company.id).then(company => {
              if (company) {
                this.props.history.push('/mobile/projects-tasks/task/' + task.id);
              }
            });
          } else {
            this.props.history.push('/mobile/projects-tasks/task/' + task.id);
          }
        } else {
          this.props.history.push('/mobile/projects-tasks/task/' + task.id);
        }
      });
    }
  }

  getProjectFromTask(task, callback) {
    dataModel.projectsDAO.getProject(task.project_id, { recordDescriptor: project_root }).then(project => {
      callback(project);
    });
  }

  navigateToProject(project_id) {
    dataModel.projectsDAO.getProject(project_id, { recordDescriptor: project_root }).then(project => {
      if ((project.company && project.company.id != this.props.currentCompany.id) ||
        (project.company_id && project.company_id != this.props.currentCompany.id)) {
        dataModel.companiesDAO.getCurrentCompany(project.company.id).then(company => {
          if (company) {
            this.props.history.push('/tasks/project/' + project.id);
          }
        });
      } else {
        this.props.history.push('/tasks/project/' + project.id);
      }
    });
  }

  navigateToMobileProject(project_id) {
    dataModel.projectsDAO.getProject(project_id, { recordDescriptor: project_root }).then(project => {
      if ((project.company && project.company.id != this.props.currentCompany.id) ||
        (project.company_id && project.company_id != this.props.currentCompany.id)) {
        dataModel.companiesDAO.getCurrentCompany(project.company.id, { recordDescriptor: { company: { directories: {}, markets: {}, vendor_users: {}, vendor_companies: {} } } }).then(company => {
          if (company) {
            this.props.history.push('/mobile/projects-tasks/project/' + project.id);
          }
        });
      } else {
        this.props.history.push('/mobile/projects-tasks/project' + project.id);
      }
    });
  }

  render() {
    const { notification, unreadClass, badge, section } = this.props;
    const isSelected = this.state.isSelected;

    const date = moment(new Date(notification.created_at));
    const dateStr = date.format('MM/DD/YY h:mm a');

    const iconsWidth = this.navigateEnabled ? 112 : 56;
    let cardSizeClass = '';
    if (isSelected) {
      cardSizeClass = this.navigateEnabled ? ' shorter' : ' short';
    }

    let hoverClass = '';
    let trashSrc = trashIcon;
    // card is to be deleted so set the display to none to prepare for animation
    if(this.state.deleting){
      trashSrc = trashFilledIcon;
      hoverClass = ' no-hover';
    }

    return (
      <div 
        id={'notification-' + notification.id} 
        className={'notification-card' + unreadClass + hoverClass} 
        key={'notification-' + notification.id}
        onClick={this.handleNotificationSelection}
      >
        {
          section == 'rejected' && 
          <div className='rejected-indicator'></div>
        }
        {
          this.closeAction && (
            <Animate
              key={'card-action-out' + notification.id}
              component_id={'card-action' + notification.id}
              duration={500}
              property={{
                width: {
                  startVal: iconsWidth,
                  endVal: 0,
                },
              }}
              completionCallback={this.handleCloseAction}
            />
          )
        }
        {isSelected && (
          <Animate
            key={'card-action-in' + notification.id}
            component_id={'card-action' + notification.id}
            duration={250}
            property={{
              width: {
                startVal: 0,
                endVal: iconsWidth,
              },
            }}
          />
        )}
        {this.state.deleteCard && (
          <Animate
            key={'card-delete' + notification.id}
            component_id={'notification-' + notification.id}
            duration={400}
            property={{
              height: {
                startVal: 64,
                endVal: 0,
              },
            }}
            completionCallback={this.handleTrashClick}
          />
        )}
        {badge}
        <div className={'notification-card-interior '}>
          <div className={'card-details' + cardSizeClass}>
            <div  className={'title' + cardSizeClass}>
              {notification.name.toUpperCase()}
            </div>
            <div  className={'notes' + cardSizeClass}>
              {notification.notes}
            </div>
          </div>
          {!isSelected && (
            <div className="card-time">
              <div className="date-time">{dateStr}</div>
              <div className="menu-selector" />
            </div>
          )}
          {isSelected && (
            <div  id={'card-action' + notification.id} className='action-container'>
              {
                 this.navigateEnabled &&
                <div  className="arrow" onClick={this.handleArrowClick}>
                  <img  src={arrowIcon} alt='' />
                </div>
              }
              <div  className="trash" onClick={this.handleDelete}>
                <img  src={trashSrc} alt='' />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

//TODO: remove dependency on redux and just pass in needed IDs/objects for routing
const mapStateToProps = (state) => {
  return {
    
    currentCompany: state.new_companies.currentCompany,
    notificationsDataModel: dataModel.notificationsDataModel,
  };
};
export default withRouter(connect(mapStateToProps)(NotificationCard));



// WEBPACK FOOTER //
// ./src/components/NotificationCard/index.js